import { render, staticRenderFns } from "./ComplaintTypeInfo.vue?vue&type=template&id=185ed3a9&"
import script from "./ComplaintTypeInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports